import { defineComponent as _defineComponent } from 'vue'
import HeaderStores from './menus/stores/HeaderStores.vue';
import Icon from 'JS/components/Icon.vue';
import MegaMenu from './menus/MegaMenu.vue';
import menuManager from '../util/menu-manager';
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { IBannerXAd } from 'JS/sponsored/sponsored-types';
import { IHeaderJson } from 'Src/js/types/Header';



export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderNavigation',
  props: {
    headerData: null,
    megaMenuAd: null
  },
  emits: ["get-mega-menu-ad", "record-ad-impression"],
  setup(__props: any, { emit }: { emit: ({
	(event: 'get-mega-menu-ad'): void;
	(event: 'record-ad-impression'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	headerData: IHeaderJson;
	megaMenuAd?: IBannerXAd;
}





const megaMenuShowing = ref(false);
const hiddenLinkWidths = ref<number[]>([]);

const megaMenuTrigger = ref<HTMLButtonElement | null>();
const megaMenuWrapperRef = ref<HTMLElement | null>();
const headerLinksContainerRef = ref<HTMLElement | null>();
const linksParentRef = ref<HTMLElement | null>();
const regAndListRef = ref<HTMLElement | null>();

const displayedHeaderLinks = computed(() => props.headerData?.headerLinks?.slice(0, props.headerData.headerLinks.length - hiddenLinkWidths.value.length) ?? []);

function handleFocusOut(e: FocusEvent) {
	const nextFocused = e.relatedTarget;

	if (megaMenuShowing.value
		&& nextFocused
		&& !megaMenuWrapperRef.value?.contains(nextFocused as Node)
 	) {
		megaMenuShowing.value = false;
	}
}

function handleMegaMenuEscape(e: KeyboardEvent) {
	if (e.key !== 'Escape' || !megaMenuShowing.value) return;
	megaMenuShowing.value = false;
	megaMenuTrigger.value.focus();
}

function toggleMegaMenu(e: MouseEvent) {
	//Stop propagation to prevent our useEventListener in MegaMenu.vue from catching this opening click
	e.stopPropagation();
	if (megaMenuShowing.value) {
		megaMenuShowing.value = false;
	} else {
		showMegaMenu();
	}
}

function showMegaMenu() {
	menuManager.closeMenus();
	megaMenuShowing.value = true;

	window.blainGtmDataLayer.push({
		'menuName': "main",
		'event': "menu_open"
	});
}

/*
	BEGINS: Header link removal and readdition
		based on screen size functionality
*/

let resizeObserver: ResizeObserver;
onMounted(async () => {
	await nextTick();
	resizeObserver = new ResizeObserver((entries) => {
		handleResizeUpdate();
	});

	resizeObserver.observe(headerLinksContainerRef.value);
	handleResizeUpdate();
});

function handleResizeUpdate() {
	if (!headerLinksContainerRef.value || !regAndListRef.value) return;

	const boundingRight = headerLinksContainerRef.value.getBoundingClientRect().right;
	let regAndListRight = regAndListRef.value.getBoundingClientRect().right;

	if (boundingRight < regAndListRight) {
		while (boundingRight < regAndListRight) {
			removeLink();
			regAndListRight -= hiddenLinkWidths.value[hiddenLinkWidths.value.length - 1];
		}
	} else {
		while (hiddenLinkWidths.value.length > 0 && boundingRight > regAndListRight + hiddenLinkWidths.value[hiddenLinkWidths.value.length - 1]) {
			regAndListRight += hiddenLinkWidths.value[hiddenLinkWidths.value.length - 1];
			addLink();
		}
	}
}

function removeLink() {
	const childBeingRemoved = linksParentRef.value.children[props.headerData.headerLinks.length - hiddenLinkWidths.value.length - 1];
	hiddenLinkWidths.value.push(childBeingRemoved.getBoundingClientRect().width);
}

function addLink() {
	hiddenLinkWidths.value.pop();
}

onBeforeUnmount(() => {
	resizeObserver?.disconnect();
});

return { __sfc: true,props, emit, megaMenuShowing, hiddenLinkWidths, megaMenuTrigger, megaMenuWrapperRef, headerLinksContainerRef, linksParentRef, regAndListRef, displayedHeaderLinks, handleFocusOut, handleMegaMenuEscape, toggleMegaMenu, showMegaMenu, resizeObserver, handleResizeUpdate, removeLink, addLink, HeaderStores, Icon, MegaMenu }
}

})